import {
  DEFAULT_SHIFT_JOB_STATUSES, DEFAULT_PLACEMENT_JOB_STATUSES,
  DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE,
  DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE,
  BOOKING_RESULT_DEFAULT_FIELDS,
  DEFAULT_DO_NOT_WANT_AGAIN_TEXT,
  DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS,
  DEFAULT_SHIFT_JOB_CALENDAR_TITLE,
  DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST,
  DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE,
  DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT,
  DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
  DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
  DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
  DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
  DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED,
  DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED,
  DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES,
  DEFAULT_PLACEMENT_JOB_TABLE_FIELDS,
  DEFAULT_PLACEMENT_JOB_FILTER_FIELDS,
  DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD,
  DEFAULT_LIST_COLORS,
  DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR
} from "../../constants/default-values";
import { FORM_TYPE, JOB_TYPES } from "../../constants/custom-define-type";
import { LIST_BOOKING_ADDRESS_FIELDS } from "../../constants/list-fields";
import axios from 'axios';
import { hasCommonElement, containsAllElements, insertArrayInArray, deduplicateArrayOfObject, cloneArrayOfObject } from "../../utils/array-handling";
import tryGet from '../../utils/try-get'
import { getRequestUrlParams } from './../../utils/data-handling';
import { appendBackgroundParam } from "../../utils/query-handling";

const state = {
  shiftJobStatuses: DEFAULT_SHIFT_JOB_STATUSES,
  placementJobStatuses: DEFAULT_PLACEMENT_JOB_STATUSES,
  jobApplications: [], // All job applications of an agency
  defaultJobBoardFields: [],
  jobBoardFieldErrors: [],
  defaultJobBoardFieldsOptions: [],
  defaultJobBoardFieldsOptionsErrors: [],
  jobPoster: {},
  jobPosterErrors: [],
  jobFiller: {},
  jobFillerErrors: [],
  mapJobNumberOfMonth: {},
  jobsNotes: [],
  jobsNotesErrors: [],
  jobId: undefined
};

const mutations = {
  setShiftJobStatuses(state, payload) {
    state.shiftJobStatuses = payload;
  },
  setPlacementJobStatuses(state, payload) {
    state.placementJobStatuses = payload;
  },
  setJobApplications(state, payload) {
    state.jobApplications = payload;
  },
  setDefaultJobBoardFields(state, jobData) {
    state.defaultJobBoardFields = jobData;
  },
  setJobBoardFieldErrors(state, error) {
    state.jobBoardFieldErrors.push(error);
  },
  resetJobBoardFieldErrors(state) {
    state.jobBoardFieldErrors = [];
  },
  setDefaultJobBoardFieldsOptions(state, jobFieldsData) {
    state.defaultJobBoardFieldsOptions = jobFieldsData
      .map((field) => {
        const text = field.replaceAll("_", " ");
        const words = text.split(" ");
        const capitalizedText = words
          .map((word) => {
            return word[0].toUpperCase() + word.substring(1);
          })
          .join(" ");
        return {
          label: capitalizedText,
          model: field,
          displayLabel: capitalizedText,
          itemPerRow: 2,
        };
      }).filter((option) => option.model !== "title");;
  },
  setJobBoardFieldsOptionsErrors(state, error) {
    state.defaultJobBoardFieldsOptionsErrors.push(error);
  },
  resetJobBoardFieldsOptionsErrors(state) {
    state.defaultJobBoardFieldsOptionsErrors = [];
  },
  setJobPoster(state, jobPosterInfo) {
    state.jobPoster = jobPosterInfo;
  },
  resetJobPosterErrors(state) {
    state.jobPosterErrors = [];
  },
  setJobFiller(state, jobFillerInfo) {
    state.jobFiller = jobFillerInfo;
  },
  resetJobFillerErrors(state) {
    state.jobFillerErrors = [];
  },
  setMapJobNumberOfMonth(state, payload) {
    state.mapJobNumberOfMonth = payload;
  },
  resetJobsNotesErrors(state) {
    state.jobsNotesErrors = [];
  },
  setJobsNotes(state, notes) {
    state.jobsNotes = notes;
  },
  setJobsNotesErrors(state, error) {
    state.jobsNotesErrors.push(error);
  },
  setJobIdForChat(state, jobId) {
    state.jobId = jobId
  }
};

const actions = {
  setShiftJobStatuses({ commit }, payload) {
    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setShiftJobStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default job statuses are used
      commit("setShiftJobStatuses", DEFAULT_SHIFT_JOB_STATUSES);
    }
  },
  setJobPoster({ commit }, payload) {
    commit("setJobPoster", payload);
  },
  setPlacementJobStatuses({ commit }, payload) {
    if (payload && Array.isArray(payload) && payload.length > 0) {
      commit("setPlacementJobStatuses", payload);
    } else {
      // If payload is invalid (not an array or empty array), default job statuses are used
      commit("setPlacementJobStatuses", DEFAULT_PLACEMENT_JOB_STATUSES);
    }
  },
  async getDefaultJobBoardFieldsOptions({ commit }) {
    commit("resetJobBoardFieldsOptionsErrors");
    await axios.get('/get-job-fields')
      .then((res) => {
        commit("setDefaultJobBoardFieldsOptions", res.data);
      })
      .catch((error) => {
        commit("setJobBoardFieldsOptionsErrors", error);
      });
  },
  createShiftJob({ commit, getters }, jobInfo) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        if (jobInfo.filler) {
          jobInfo.fillers = [jobInfo.filler];
        }
        jobInfo.filler = null;
        jobInfo.filler_name = "";
      }
      const res = await axios.post("/api/jobs/", jobInfo);
      resolve(res.data);
    });
  },
  updateShiftJob({ commit, getters }, { id, jobInfo }) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        if (jobInfo.filler) {
          jobInfo.fillers = [jobInfo.filler];
        }
      }
      const res = await axios.patch(`/api/jobs/${id}/`, jobInfo);
      resolve(res.data);
    });
  },
  addABreak({ commit, getters }, { job, breakInfo }) {
    return new Promise(async (resolve) => {
      if (!job.breaks) {
        job.breaks = [];
      }
      job.breaks.push(breakInfo);
      const res = await axios.patch(`/api/jobs/${job.id}/`, { breaks: job.breaks });
      resolve(res.data);
    });
  },
  removeABreak({ commit, getters }, { job, index }) {
    return new Promise(async (resolve) => {
      if (!job.breaks) {
        resolve();
      }
      job.breaks.splice(index, 1);
      const res = await axios.patch(`/api/jobs/${job.id}/`, { breaks: job.breaks });
      resolve();
    });
  },
  updateFillersOfJob({ commit, getters }, { job, filled, filler, fillers, status, notAllowStatus }) {
    return new Promise(async (resolve) => {
      await axios.patch(`/job-fillers/${job.id}/`, {
        job_id: job.id,
        filler_id: filler ? filler.id : null,
        filled: filled,
        filler_ids: fillers ? fillers.map(filler => filler.id) : null,
        info: { status: status },
        not_allowed_status: notAllowStatus
      });
      resolve();
    });
  },
  assignShiftJob({ commit, getters }, { job, filler, checkJobStatus, additionalInfo }) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        const res = await axios.post('/job-fillers/', {
          job_id: job.id,
          filler_id: filler.id,
          check_job_status: true, // Check if job was accepted by other user
          additional_info: additionalInfo
        });
        if (!res) {
          resolve(false);
        }
      } else {
        let requestBody = {
          status: "Assigned",
          filled: true,
          filler: filler.id,
          filler_name: `${filler.first_name} ${filler.last_name}`,
          filled_date: new Date(),
          action_type: 'Assign Job',
          check_job_status: checkJobStatus, // Check if job was accepted by other user
        }
        if (additionalInfo) {
          requestBody = {
            ...requestBody,
            ...additionalInfo
          }
        }
        const res = await axios
          .patch(`/api/jobs/${job.id}/`, requestBody);
        if (!res) {
          resolve(false);
        }
      }
      resolve(true);
    });
  },
  unassignShiftJob({ commit, getters }, { job, fillerId }) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        if (fillerId) {
          // Unassign one
          await axios.delete(`/job-fillers/${job.id}/${fillerId}/`);
        } else {
          // Unassign all
          await axios.delete(`/job-fillers/${job.id}/`);
        }
      } else {
        let unassignStatus = getters.shiftJobCandidateUnassignStatus ? getters.shiftJobCandidateUnassignStatus : 'Requested'
        await axios
          .patch(`/api/jobs/${job.id}/`, {
            status: unassignStatus,
            filled: false,
            filler: null,
            filler_name: ``,
            filled_date: null,
            action_type: 'Unassign Job',
          })
      }
      resolve();
    });
  },
  getShiftJobsMainInfo({ commit, getters }, {
    startDate, endDate, includeDateRange, isBackground
  }) {
    return new Promise(async (resolve) => {
      let additionalUrlParam = includeDateRange ? '&include_date_range=true' : '';
      if (isBackground) {
        additionalUrlParam = `${additionalUrlParam}&in_background=true`;
      }
      // Get job fillers
      let jobFillers = [];
      if (getters.multipleFillersShiftJob) {
        const jobFillerRes = await axios.get(`/job-fillers/?start_date=${startDate
          }&end_date=${endDate}${additionalUrlParam}`);
        jobFillers = jobFillerRes.data.job_fillers;
      }
      const res = await axios.get(`/get-jobs/?job_type=${getters.jobTypeShortTermQuery}&start_date=${startDate
        }&end_date=${endDate}&main_info_only=true${additionalUrlParam}`);
      const listJobs = Array.isArray(res.data) ? res.data : res.data.jobs;
      if (getters.multipleFillersShiftJob) {
        listJobs.forEach(job => {
          // Get fillers and fillers name for each job
          const listFillers = jobFillers.filter(jobFiller => jobFiller.job === job.id);
          job.fillers = listFillers.map(filler => filler.filler);
          job.filler_name = listFillers.map(filler => filler.filler_name).join(', ');
          job.filler = null;
          job.fillers_info = listFillers.map(filler => ({
            ...filler,
            ...filler.info
          }));
        });
      }
      resolve(listJobs);
    });
  },
  getJobFullInfo({ commit, getters }, inputJob) {
    return new Promise(async (resolve) => {
      let job = inputJob
      const res = await axios.get(`/api/jobs/${inputJob.id}/`);
      if (res && res.data) {
        job = res.data;
      }
      resolve(job);
    });
  },
  getFillersOfJob({ commit, getters }, job) {
    return new Promise(async (resolve) => {
      if (!job.id) {
        resolve([]);
        return;
      }
      const res = await axios.get(`/job-fillers/${job.id}/?filler_detail=true`);
      resolve(res.data.job_fillers);
    });
  },
  getJobFiller({ commit, getters }, job) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/job-fillers/${job.id}/`);
      let listJobFillers = res.data.job_fillers;
      listJobFillers.forEach(jobFiller => jobFiller.id = jobFiller.filler_id);
      listJobFillers = listJobFillers.sort((filler1, filler2) => filler1.id < filler2.id ? 1 : -1);
      resolve(listJobFillers);
    });
  },
  updateJobFiller({ commit, getters }, { jobId, fillerId, info }) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        const requestBody = { info: info };
        if (info.status) {
          requestBody.status = info.status;
        }
        await axios.patch(`/job-fillers/${jobId}/${fillerId}/`, requestBody);
      } else {
        await axios.patch(`/api/jobs/${jobId}/`, info);
      }
      resolve();
    });
  },
  updateJob({ commit, getters }, { jobId, info }) {
    return new Promise(async (resolve) => {
      const res = await axios.patch(`/api/jobs/${jobId}/`, info);
      if (res && res.data) {
        resolve(res.data);
      } else {
        resolve();
      }
    });
  },
  getJobById({ commit, getters }, jobId) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/api/jobs/${jobId}/`);
      const job = res.data;
      if (getters.multipleFillersShiftJob) {
        if (job.fillers) {
          job.filler_name = job.fillers.map(filler => `${filler.first_name} ${filler.last_name}`).join(', ');
        } else {
          job.filler_name = null;
        }
        if (!job.filled) {
          job.filler = null;
        }
      }
      resolve(job);
    });
  },
  getJobsByFiller({ commit, getters }, fillerId) {
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        const jobFillerRes = await axios.get(`/job-fillers/?filler=${fillerId}&job_detail=true`);
        const jobFillers = jobFillerRes.data.job_fillers;
        jobFillers.forEach(job => {
          if (!job.fillers) {
            job.fillers = [{
              id: fillerId
            }]
          }
        })
        resolve(jobFillers);
        return;
      } else {
        const res = await axios.get(`/api/jobs/?filler=${fillerId}`);
        const listJobs = res.data;
        if (getters.clientCanSelectMultipleCandidates) {
          const jobFillerRes = await axios.get(`/job-fillers/?filler=${fillerId}&job_detail=true`);
          const jobFillers = jobFillerRes.data.job_fillers;
          resolve(deduplicateArrayOfObject([...listJobs, ...jobFillers], 'id'));
        } else {
          resolve(listJobs);
        }
      }
    });
  },
  async getJobsByFillerWithFilter({ commit, getters }, payload) {
    let queryParams = `filler=${payload.fillerId}`
    if (payload.startDate) {
      queryParams += `&start_date=${payload.startDate}`;
    }
    if (payload.endDate) {
      queryParams += `&end_date=${payload.endDate}`;
    }
    if (payload.reports) {
      queryParams += `&reports=true`;
    }
    if (payload.additionalFields) {
      queryParams += `&additional_fields=${payload.additionalFields.join(',')}`;
    }
    return new Promise(async (resolve) => {
      if (getters.multipleFillersShiftJob) {
        const jobFillerRes = await axios.get(`/job-fillers/?job_detail=true&${queryParams}`);
        if (!jobFillerRes || !jobFillerRes.data) {
          resolve([]);
          return;
        }
        const jobFillers = jobFillerRes.data.job_fillers;
        if (payload.fillerId) {
          jobFillers.forEach(job => {
            job.fillers = [
              { id: payload.fillerId }
            ]
          })
        }
        resolve(jobFillers);
        return;
      } else {
        const res = await axios.get(`/get-jobs/?${queryParams}`);
        if (!res || !res.data) {
          resolve([]);
          return;
        }
        const listJobs = res.data.jobs;
        if (getters.clientCanSelectMultipleCandidates) {
          const jobFillerRes = await axios.get(`/job-fillers/?job_detail=true&${queryParams}`);
          const jobFillers = jobFillerRes.data.job_fillers;
          resolve(deduplicateArrayOfObject([...listJobs, ...jobFillers], 'id'));
        } else {
          resolve(listJobs);
        }
      }
    });
  },
  getJobsByGroup({ commit, getters }, groupId) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/api/jobs/?job_group=${groupId}`);
      resolve(res.data);
    });
  },
  getJobApplications({ commit, getters }, additionalInfo) {
    return new Promise(async (resolve) => {
      let jobApplications = [];
      let url = '/get-job-applications/';
      if (additionalInfo) {
        if (additionalInfo.clientId && additionalInfo.candidateId) {
          url = `${url}?client=${additionalInfo.clientId}&candidate=${additionalInfo.candidateId}`
        }
      }
      const res = await axios.get(url);
      if (res && res.data && res.data.jobapplications) {
        jobApplications = res.data.jobapplications;
        jobApplications = jobApplications.filter(
          (application) => application.status !== "Declined"
        );
      }
      commit('setJobApplications', jobApplications);
      resolve(jobApplications);
    });
  },
  async getJobPosterById({ commit }, posterId) {
    commit('resetJobPosterErrors');
    if (!posterId) {
      return;
    }
    await axios.get(`/api/people/${posterId}/`)
      .then(res => {
        commit('setJobPoster', res.data);
      })
      .catch(error => {
        state.jobPosterErrors.push(error);
      })
  },
  async getJobFillerById({ commit }, fillerId) {
    commit('resetJobFillerErrors');
    if (!fillerId) {
      return;
    }
    await axios.get(`/api/people/${fillerId}/`)
      .then(res => {
        console.log('res filler ===>', res, res.data)
        commit('setJobFiller', res.data);
      })
      .catch(error => {
        state.jobPosterErrors.push(error);
      })
  },
  setMapJobNumberOfMonth({ commit }, payload) {
    commit('setMapJobNumberOfMonth', payload);
  },
  getUserDeviceId({ commit }, userId) {
    return new Promise(async (resolve) => {
      const res = await axios.get(`/api/people/${userId}/`);
      resolve(res.data.device_id);
    });
  },
  async addAdditionalDates({ commit }, payload) {
    return new Promise(async (resolve) => {
      const res = await axios.post(`/api/jobs/${payload.jobId}/add_additional_dates/`, payload);
      resolve(res.data);
    });
  },
  async getJobsNotes({ commit, rootGetters }) {
    commit("resetJobsNotesErrors");
    await axios.get(`get-notes?agency=${rootGetters.agencyID}&type=job`)
      .then((res) => {
        commit("setJobsNotes", res.data.notes);
      })
      .catch((error) => {
        commit("setJobsNotesErrors", error.message);
      });
  },
  async sendNotificationEnginehireApp({ commit }, payload) {
    return new Promise(async (resolve) => {
      const res = await axios.post(appendBackgroundParam('/optimum/send_notification_app/'), payload);
      resolve(res.data);
    });
  },
  async getActionList(_, payload) {
    return await new Promise((resolve, reject) => {
      let url = `optimum/optimize/actions/?`
      if (payload) {
        url = `${url}&${getRequestUrlParams(payload)}`
      }
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            resolve(response);
          }
        }).catch((err) => {
          reject(err)
        });
    })
  },
  async getJobList(_, payload) {
    return await new Promise((resolve, reject) => {
      let url = `optimize/get-all-jobs/?`
      if (payload) {
        url = `${url}&${getRequestUrlParams(payload)}`
      }
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            resolve(response);
          }
        }).catch((err) => {
          reject(err)
        });
    })
  },
  async getJobApplicationList(_, payload) {
    return await new Promise((resolve, reject) => {
      let url = `optimize/get-jobapplication/?`
      if (payload) {
        url = `${url}&${getRequestUrlParams(payload)}`
      }
      axios.get(url)
        .then((response) => {
          if (response.status === 200) {
            resolve(response);
          }
        }).catch((err) => {
          reject(err)
        });
    })
  },

  async updateBroadcastedCandidateId({ commit }, broadcastpayload,) {
    const payload = {
      "broadcasted_candidates_ids": [...broadcastpayload.broadcastIds],
      "broadcasted": true
    }
    await axios.patch(`/api/jobs/${broadcastpayload.jobId}/`, payload)

  },

  setJobIdForChat({ commit }, jobId) {
    commit('setJobIdForChat', jobId)
  }
};










const getters = {
  mapJobNumberOfMonth: state => state.mapJobNumberOfMonth || {},
  jobPoster: state => tryGet(() => state.jobPoster) || {},
  jobFiller: state => tryGet(() => state.jobFiller) || {},
  jobPosterErrors: state => tryGet(() => state.jobPosterErrors) || [],
  jobFillerErrors: state => tryGet(() => state.jobFillerErrors) || [],
  jobTypeShortTermQuery(state, getters) {
    // For agency 16 (thenannycompany), job_type is not Short Term and Long Term
    if (Number(getters.agencyID) === 16) {
      return '';
    }
    return 'Short Term';
  },
  shiftJobStatuses(state) {
    const result = state.shiftJobStatuses;
    if (!result.some(item => item.status === 'Charged')) {
      result.push({ status: "Charged", color: DEFAULT_LIST_COLORS[7] })
    }
    return result;
  },
  defaultJobBoardFields: state => tryGet(() => state.defaultJobBoardFields) || [],
  jobBoardFieldErrors: state => tryGet(() => state.jobBoardFieldErrors) || [],
  defaultJobBoardFieldsOptions: state => tryGet(() => state.defaultJobBoardFieldsOptions) || [],
  defaultJobBoardFieldsOptionsErrors: state => tryGet(() => state.defaultJobBoardFieldsOptionsErrors) || [],
  jobApplications(state) {
    return state.jobApplications;
  },
  placementJobStatuses(state) {
    return state.placementJobStatuses;
  },
  jobTypes(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (
      agency &&
      agency.job_types &&
      agency.job_types.length) {
      return agency.job_types;
    }
    return Object.values(JOB_TYPES);
  },
  listPlacementJobTypes(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic
    if (agency) {
      if (
        agency.public_advance_setting
      ) {
        const listTypes =
          agency.public_advance_setting
            .placement_job_types;
        if (listTypes) {
          return listTypes;
        }
      }
    }
    return [];
  },
  clientCanAssignShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.advance_setting &&
      agency.advance_setting.client_can_assign_shift_job) {
      return agency.advance_setting.client_can_assign_shift_job;
    }
    return false;
  },
  clientCanExpressInterestShiftJob(state, getters, rootState) {
    if (getters.clientCanAssignShiftJob) {
      return false;
    }
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.advance_setting &&
      agency.advance_setting.client_can_express_interest_shift_job) {
      return agency.advance_setting.client_can_express_interest_shift_job;
    }
    return false;
  },
  clientCanAcceptCandidateShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.advance_setting &&
      agency.advance_setting.client_can_accept_candidate_shift_job) {
      return agency.advance_setting.client_can_accept_candidate_shift_job;
    }
    return false;
  },
  clientCanAssignShiftJobApplicationForm(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.client_can_assign_shift_job_application_form;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  multipleFillersShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.advance_setting &&
      agency.advance_setting.multiple_fillers_shift_job) {
      return agency.advance_setting.multiple_fillers_shift_job;
    }
    return false;
  },
  sendNotificationToFillerOnChange(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency &&
      agency.advance_setting &&
      agency.advance_setting.send_notification_to_filler_on_change != null) {
      return agency.advance_setting.send_notification_to_filler_on_change;
    }
    return true;
  },
  canSeeShiftJobOutsideLocation(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.can_see_shift_job_outside_location;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  canSeePlacementJobOutsideLocation(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.can_see_placement_job_outside_location;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  isManualClocking(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.manual_clocking) {
      return agency.manual_clocking;
    }
    return false;
  },
  minuteIntervalClockInOut(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.minute_interval_clock_in_out) {
      return agency.advance_setting.minute_interval_clock_in_out;
    }
    return 15; // Default is 15 minutes
  },
  listShiftJobStatuses(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    let listItems = DEFAULT_SHIFT_JOB_STATUSES;
    if (agency && agency.shift_job_statuses && agency.shift_job_statuses.length) {
      listItems = agency.shift_job_statuses;
    }
    return listItems.map(item => item.status);
  },
  startDayOfWeekCalendar(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.start_day_of_week;
      if (result != null) {
        return result;
      }
    }
    return 0; // Default is 0
  },
  shiftJobCalendarClientNameModel(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.shift_job_calendar_client_name_model) {
      return agency.advance_setting.shift_job_calendar_client_name_model;
    }
    return 'name'; // Default is name (first_name + last_name)
  },
  canOnlySeeShiftJobMatchedTags(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.can_only_see_shift_job_matched_tags;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  canOnlySeeShiftJobMatchedTypesCategory(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.can_only_see_shift_job_matched_types_category;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showChildrenShiftJob(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.show_children_shift_job;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showPetsShiftJob(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.show_pets_shift_job;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  showPosterTagShiftJobBoard(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.show_poster_tag_shift_job_board;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  customTextCancelingShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.custom_text_canceling_shift_job) {
      return agency.advance_setting.custom_text_canceling_shift_job;
    }
  },
  candidateCanDeclinedShiftJobs(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.candidate_can_declined_shift_jobs) {
      return agency.advance_setting.candidate_can_declined_shift_jobs;
    }
    return false;
  },
  clientCanReceiveEmailDeclinedJobs(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.client_can_recieve_email_declined_jobs;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  jobStatusesCandidateCanDecline(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.job_statuses_candidate_can_decline) {
      return agency.advance_setting.job_statuses_candidate_can_decline;
    }
    return ['Assigned'];
  },
  numberOfHoursCanDeclineShiftJobs(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.number_hours_can_decline_jobs) {
      return agency.advance_setting.number_hours_can_decline_jobs;
    }
    return 24;
  },
  onlyShowMatchedTags(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting &&
      agency.advance_setting.only_show_matched_tags) {
      return agency.advance_setting.only_show_matched_tags;
    }
    return false;
  },
  onlyShowMatchedLocations(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.only_show_matched_locations;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  clientSelectionCandidateTypes(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.client_selection_candidate_types;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  clientSelectionCandidateStatuses(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.client_selection_candidate_statuses;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  hideUnavailableCandidatesDefaultForAdmin(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.admin_default_hide_unavailable_candidates;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  hideUnavailableCandidatesDefaultSchedulerView(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.scheduler_view_default_hide_unavailable_candidates;
      if (result != null) {
        return result;
      }
    }
    return true;
  },
  hasShiftJobApproveButton(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.has_shift_job_approve_button;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  showIdShiftJobCalendar(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.show_id_shift_job_calendar;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  statusOnApproving(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.status_on_approving;
      if (result) {
        return result;
      }
    }
    return "Approved";
  },
  shiftJobActiveTypes(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.shift_job_active_types;
      if (result != null) {
        return result;
      }
    }
    if (agency && agency.candidate_types) {
      return agency.candidate_types;
    }
    return [];
  },
  initFilterStatusCandidateListAdmin(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.init_filter_status_candidate_list_admin;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  showWeeklyScheduleReleaseButton(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.show_weekly_schedule_release_button;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  clientCanSelectMultipleCandidates(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.client_can_select_multiple_candidates;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  jobStatusesRefund(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.job_statuses_refund;
      if (result != null) {
        return result;
      }
    }
    return [];
  },
  onlyRefundForNonFilledJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.only_refund_non_filled_job;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  onlyRefundForFilledJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.only_refund_filled_job;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  jobStatusAfterClientSelectCandidate(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.job_status_after_client_select_candidate;
      if (result != null) {
        return result;
      }
    }
    return "Assigned";
  },
  tentativeAssignStatus(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.tentative_assign_status;
      if (result != null) {
        return result;
      }
    }
    return "Tentatively Assigned";
  },
  preReleaseShiftJobStatus(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.pre_release_shift_job_status;
      if (result != null) {
        return result;
      }
    }
    return "Tentatively Assigned";
  },
  hideCandidatePreReleaseStatus(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.hide_candidate_pre_realease;
      if (result != null) {
        return result;
      }
    }
    return false;
  },
  postReleaseShiftJobStatus(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.post_release_shift_job_status;
      if (result != null) {
        return result;
      }
    }
    return "Assigned";
  },
  shiftJobStatusClientCanCancel(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.shift_job_status_client_can_cancel;
      if (result) {
        return result;
      }
    }
    return getters.listShiftJobStatuses;
  },
  JobStatusClientCantEditShiftBookings(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.job_status_client_cant_edit_shift_booking;
      if (result) {
        return result;
      }
    }
    return [];
  },
  defaultCandidateStatusShiftJobBroadcast(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const result = agency.advance_setting.default_candidate_statuses_shift_job_broadcast;
      if (result) {
        return result;
      }
    }
    return [];
  },
  isEmailCandidateJobAcceptted(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.send_email_candidate_accept_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  isEmailClientJobAcceptted(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.send_email_client_accept_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  acceptJobsByGroup(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.accept_jobs_by_group;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  shiftRequestMinimumHours(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency) {
      const result = agency.shift_request_minimum_hours;
      if (result && !isNaN(result)) {
        return Number(result);
      }
    }
    return 4; // Default is false
  },
  // Min between all client types
  shiftRequestMinimumHoursAllTypes(state, getters, rootState) {
    let min = getters.shiftRequestMinimumHours;
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const minPerTypes = agency.advance_setting.minimum_hours_per_types;
      if (minPerTypes) {
        for (const hourType of minPerTypes) {
          if (hourType.minimun_hours && !isNaN(hourType.minimun_hours)) {
            const hours = Number(hourType.minimun_hours);
            if (hours < min) {
              min = hours;
            }
          }
        }
      }
    }
    return min;
  },
  employerShiftRequestEmails(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (!agency || !agency.employer_shift_request_emails) {
      return [];
    }
    // Don't send notification email to admin if she is the one who created the booking
    const userEmail = rootState.authentication.userEmail;
    return agency.employer_shift_request_emails.filter(email => email !== userEmail);
  },
  hideHourlyRateFromCandidates(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.hide_hourly_rate_from_candidates;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  autoAssignCandidate(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.auto_assign_candidate;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  messageNobodyAvailable(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.message_nobody_available;
      if (result) {
        return result;
      }
    }
    return DEFAULT_MESSAGE_AUTO_ASSIGN_NO_CANDIDATE;
  },
  textSelfSelectNobodyAvailable(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.text_nobody_available;
      if (result) {
        return result;
      }
    }
    return DEFAULT_MESSAGE_SELF_SELECT_NO_AVAILABLE;
  },
  visibleToAssignCandidates(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.visible_to_assign_candidates;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  checkHideBookedCandidatesBroadcast(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.check_hide_booked_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  showAnalyticsByDefaultPlacementJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.show_analytics_by_default_placement_job;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  customFilterFieldsPlacementJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.placement_job_custom_filter_fields;
      if (result && result.length) {
        return result;
      }
    }
    return DEFAULT_PLACEMENT_JOB_FILTER_FIELDS;
  },
  checkHideTimeOffCandidatesBroadcast(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.check_hide_timeoff_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  checkHideUnavailableCandidatesBroadcast(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.check_hide_unavailable_candidates_broadcast;
      if (result != null) {
        return result;
      }
    }
    return true; // Default is true
  },
  jobStatusAfterBroadcasting(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.job_status_after_broadcasting;
      if (result) {
        return result;
      }
    }
    return "Broadcasted"; // Default is Broadcasted
  },
  shiftJobDistanceToShowOnJobBoard(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      return agency.public_advance_setting.shift_job_distance_to_show_on_job_board;
    }
    return null; // Default is null
  },
  placementJobDistanceToShowOnJobBoard(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      return agency.public_advance_setting.placement_job_distance_to_show_on_job_board;
    }
    return null; // Default is null
  },
  shiftJobCalendarResultFields(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency.advance_setting) {
      const result = agency.advance_setting.shift_job_calendar_result_fields;
      if (result && result.length) {
        return result;
      }
    }
    return BOOKING_RESULT_DEFAULT_FIELDS;
  },
  notifyClientWhenInterestShift(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.notify_client_when_interest_shift;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  notifyClientWhenInterestPlacement(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency.public_advance_setting) {
      const result = agency.public_advance_setting.notify_client_when_interest_placement;
      if (result != null) {
        return result;
      }
    }
    return false; // Default is false
  },
  listBreakDurationOptionList() {
    return [
      {
        label: "15 minutes",
        id: 0.25,
      },
      {
        label: "30 minutes",
        id: 0.5,
      },
      {
        label: "45 minutes",
        id: 0.75,
      },
      {
        label: "1 hour",
        id: 1,
      },
      {
        label: "1 hour and 15 minutes",
        id: 1.25,
      },
      {
        label: "1 hour and 30 minutes",
        id: 1.5,
      },
      {
        label: "1 hour and 45 minutes",
        id: 1.75,
      },
      {
        label: "2 hours",
        id: 2,
      },
    ]
  },
  addBreakListFields(state, getters) {
    return [
      {
        label: "Start Time of the break",
        model: "start_time",
        type: FORM_TYPE.TIME_PICKER,
        itemPerRow: 2,
      },
      {
        label: "How long",
        model: "duration",
        type: FORM_TYPE.MULTI_SELECT,
        optionLabel: "label",
        optionModel: "id",
        optionList: getters.listBreakDurationOptionList,
        itemPerRow: 2,
      },
      {
        label: "Note",
        isRequired: false,
        model: "note",
        type: FORM_TYPE.TEXTAREA,
      },
    ];
  },
  shiftJobCalendarSearchFields(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const listFields = agency.advance_setting.shift_job_calendar_search_fields;
      if (listFields && listFields.length) {
        return listFields;
      }
    }
    return [];
  },
  defaultHiddenPlacementJobStatus(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (agency && agency.public_advance_setting) {
      const listFields = agency.public_advance_setting.default_hidden_placement_job_status;
      if (listFields) {
        return listFields;
      }
    }
    return ["Filled", "Closed", "Draft"];
  },
  placementJobTableFields(state, getters, rootState, rootGetters) {
    let result = DEFAULT_PLACEMENT_JOB_TABLE_FIELDS;
    const agency = rootState.authentication.agency;
    if (agency && agency.advance_setting) {
      const listFields = agency.advance_setting.placement_job_table_fields;
      if (listFields) {
        result = listFields;
      }
    }
    const listTypes = rootGetters.listPlacementJobTypes;
    // Check to display job categories column
    if (!listTypes || !listTypes.length) {
      result = result.filter(item => item.model !== 'types');
    }
    return result;
  },
  hasNotifyCandidateAssignShiftJob(state, getters) {
    return getters.sendCandidateAssignConfirmationEmailShiftJob ||
    getters.sendSMSCandidateNotificationOnAssignJob
  },
  hasNotifyClientAssignShiftJob(state, getters) {
    return getters.sendClientAssignConfirmationEmailShiftJob ||
    getters.sendSMSClientNotificationOnAssignJob
  },
  sendCandidateAssignConfirmationEmailShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency && agency.advance_setting &&
      agency.advance_setting.hasOwnProperty('send_candidate_assign_confirmation_email_shift_job')) {
      return agency.advance_setting.send_candidate_assign_confirmation_email_shift_job;
    }
    return true;
  },
  sendClientAssignConfirmationEmailShiftJob(state, getters, rootState) {
    const agency = rootState.authentication.agency;
    if (
      agency && agency.advance_setting &&
      agency.advance_setting.hasOwnProperty('send_client_assign_confirmation_email_shift_job')) {
      return agency.advance_setting.send_client_assign_confirmation_email_shift_job;
    }
    return true;
  },
  listPlacementJobStatuses(state, getters, rootState) {
    const agency = rootState.agency;
    if (
      agency && agency.agencyPublic &&
      agency.agencyPublic.placement_job_statuses &&
      agency.agencyPublic.placement_job_statuses.length != 0) {
      return agency.agencyPublic.placement_job_statuses;
    } else {
      return DEFAULT_PLACEMENT_JOB_STATUSES;
    }
  },
  sendSMStoCandidateWhenJobIsCancelled(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_sms_to_candidate_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_sms_to_candidate_when_job_is_cancelled
    } else {
      return true
    }
  },
  sendSMStoClientWhenJobIsCancelled(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty("send_sms_to_client_when_job_is_cancelled")) {
      return agency.public_advance_setting.send_sms_to_client_when_job_is_cancelled
    }
    else {
      return true
    }
  },
  sendEmailtoCandidateWhenJobIsCancelled(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_email_to_candidate_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_email_to_candidate_when_job_is_cancelled
    }
    else {
      return true
    }
  },
  sendEmailtoClientWhenJobIsCancelled(state, getters, rootState) {
    const agency = rootState.agency.agencyPublic;
    if (!agency || !agency.public_advance_setting) {
      return true;
    }
    if (agency.public_advance_setting.hasOwnProperty('send_email_to_client_when_job_is_cancelled')) {
      return agency.public_advance_setting.send_email_to_client_when_job_is_cancelled
    }
    else {
      return true
    }
  },
  mapShiftJobCategoryColor(state, getters, rootState) {
    const listCategoryColor = tryGet(() => rootState.agency.agencyPublic.public_advance_setting.shift_job_category_color)
    if (!listCategoryColor) {
      return {}
    }
    const result = {};
    for (const item of listCategoryColor) {
      result[item.category] = item.color;
    }
    return result;
  },
  mapShiftJobLocationColor(state, getters, rootState) {
    const listLocationColor = tryGet(() => rootState.agency.agencyPublic.public_advance_setting.shift_job_location_color)
    if (!listLocationColor) {
      return {}
    }
    const result = {};
    for (const item of listLocationColor) {
      result[item.location] = item.color;
    }
    return result;
  },
  jobsNotes: state => tryGet(() => state.jobsNotes) || [],
  jobsNotesErrors: state => tryGet(() => state.jobsNotesErrors) || [],
  hasReportProblemButton: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.has_report_problem_button) || false,
  reportProblemButtonText: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_button_text) || DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
  reportProblemUploadFilesLabel: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_upload_file_label) || DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
  reportProblemUploadFilesDescription: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_upload_file_description) || DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
  reportProblemNoteLabel: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_note_label) || DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
  reportProblemNotificationEmails: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_notification_emails) || [],
  reportProblemNewJobStatus: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.report_problem_new_job_status) || "",
  clientHasReportProblemButton: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.has_report_problem_button_for_client) || false,
  clientReportProblemButtonText: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_button_text) || DEFAULT_CANDIDATE_JOB_REPORT_PROBLEM_BUTTON_TEXT,
  clientReportProblemUploadFilesLabel: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_upload_file_label) || DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_LABEL,
  clientReportProblemUploadFilesDescription: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_upload_file_description) || DEFAULT_REPORT_PROBLEM_UPLOAD_FILE_DESCRIPTION,
  clientReportProblemNoteLabel: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_note_label) || DEFAULT_REPORT_PROBLEM_NOTE_LABEL,
  clientReportProblemNotificationEmails: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_notification_emails) || [],
  clientReportProblemNewJobStatus: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.client_report_problem_new_job_status) || "",
  shiftJobCancellationReasonList: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.shift_job_cancellation_reason_list) || DEFAULT_SHIFT_JOB_CANCELLATION_REASON_LIST,
  listShiftJobStatusesCancelled: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.list_shift_job_statuses_cancelled) || ["Cancelled"],
  disableLocationFilterShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.disable_location_filter_shift_job) || false,
  hideLocationFilterShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_location_filter_shift_job) || false,
  broadcastOnCreateJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.broadcast_on_create_job) || false,
  jobBoardBackgroundColor: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_board_bg_color) || '#ffffff',
  jobBoardFontColor: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_board_font_color) || '#000000',
  jobBoardVisibleFields: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_board_visible_fields) || [],
  notifyAllApplicants: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.notify_all_applicants) || false,
  jobBoardFullWidthBarMode: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_board_full_width_bar_mode) || false,
  showImageJobBoardFullWidthBarMode: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_image_job_board_full_width_bar_mode) || false,
  showHiredBadgeOnJobBoard: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_hired_badge_on_job_board) || false,
  hideCandidateLastNameForShiftJobs: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.hide_candidate_last_name_for_shift_jobs) || false,
  filterTimeSheetsByWeekDay: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.filter_time_sheets_by_week_day) || false,
  hideDistanceViewingPlacementJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_distance_viewing_placement_job) || false,
  hideDistanceViewingShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_distance_viewing_shift_job) || false,
  hideChangeResponseShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_change_response_shift_job) || false,
  hideChangeResponsePlacementJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_change_response_placement_job) || false,
  placementJobBroadcastStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.placement_job_broadcast_statuses) || [],
  placementJobViewingStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.placement_job_viewing_statuses) || [],
  placementJobViewingTypes: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.placement_job_viewing_types) || [],
  shiftJobViewingStatuses: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.shift_job_viewing_statuses) || [],
  shiftJobViewingTags: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.shift_job_viewing_tags) || [],
  createBookingGroupNotificationEmails: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.create_booking_group_emails) || [],
  doNotWantAgainText: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_do_not_want_again_text) || DEFAULT_DO_NOT_WANT_AGAIN_TEXT,
  shiftJobCandidateUnassignStatus: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.shift_job_candidate_unassign_status) || '',
  showAddressShiftJobCalendar: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.show_address_shift_job_calendar) || false,
  jobStatusesToHideSchedulerView: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.job_statuses_to_hide_scheduler_view) || ['Assigned'],
  shiftJobStatusesWhereJobStatusVisible: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.shift_job_statuses_where_job_status_visible_to_client) || ['Cancelled'],
  jobDetailViewVisibleFields: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_board_detail_view_fields) || DEFAULT_PLACEMENT_JOB_DETAIL_VIEW_FIELDS,
  hideFromJobBoardCheckedByDefault: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_from_job_board_checked_by_default) || false,
  selectedMyJobsTableColumns: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.my_jobs_table_columns) || [],
  hideClientNameCandidateViewAvailableShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.hide_client_name_candidate_viewing_available_shift_job) || false,
  doNotAutoPopulateAddress: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.do_not_auto_populate_address) || false,
  wordUsedForInterestedInJobLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.word_used_for_intereseted_in_opportunity) || "Interested in this opportunity?",
  wordUsedForApplyNowButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.word_used_for_apply_now_btn) || "Apply Now",
  wordUsedForAlreadySubmittedLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.word_used_for_already_submitted_label) || "Already submitted an application previously?",
  wordUsedForLoginToSubmitApplicationButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.word_used_for_login_to_submit_btn) || "Log in to Submit your Application",
  customTextShiftJobAccepted: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_text_shift_job_accepted) || "",
  defaultCandidateTypesShiftJobBroadcast: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.default_candidate_types_shift_job_broadcast) || [],
  defaultCandidateTagsShiftJobBroadcast: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.default_candidate_tags_shift_job_broadcast) || [],
  doNotAskReasonClientCancelsShiftJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.do_not_ask_reason_client_cancels_shift_job) || false,
  checkHideCandidateWithNoMatchingTags: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.hide_candidates_no_matching_tag_broadcast) || false,
  checkHideCandidateDoNotMatchList: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.hide_candidates_do_not_match_list) || true,
  defaultFilterJobStatusesShiftJobCalendar: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.default_filter_job_statuses_shift_job_calendar) || [],
  customizeConfirmTextAcceptJob: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_confirm_text_accept_job) || DEFAULT_CANDIDATE_ACCEPT_JOB_CONFIRM_MESSAGE,
  customizeConfirmTextAcceptJobButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_confirm_text_accept_job_button) || DEFAULT_CANDIDATE_ACCEPT_JOB_BUTTON_TEXT,
  showShiftJobBoardInternally: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.show_shift_job_board_internally) || false,
  customClockoutMessage: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.candidate_custom_clockout_message) || false,
  showPlacedJobsOnJobBoard: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.show_placed_jobs_on_job_board) || false,
  shiftJobViewingTypes: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.shift_job_viewing_types) || [],
  includeBookingCancelReasonInCandidateEmail: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.include_booking_cancel_reason_candidate_email) || false,
  defaultCandidateStatusesAppearAssigningCandidate: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.default_candidate_statuses_appear_assigning_candidate) || [],
  defaultCandidateTypesAppearAssigningCandidate: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.default_candidate_types_appear_assigning_candidate) || [],
  doNotWarnAboutCandidateAvailability: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.do_not_warn_about_candidate_availability) || false,
  skipCandidateConflictCheck: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.skip_candidate_conflict_check) || false,
  candidateCanMarkJobAsCompleted: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.candidate_can_mark_job_as_completed) || false,
  buttonTextCandidateMarkJobCompleted: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.mark_job_completed_button_text) || DEFAULT_BUTTON_TEXT_CANDIDATE_MARK_JOB_COMPLTED,
  statusCandidateMarkJobCompleted: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.job_status_after_candidate_mark_job_completed) || DEFAULT_STATUS_CANDIDATE_MARK_JOB_COMPLTED,
  chargeTransferIncludeMileage: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.charge_transfer_include_mileage) || false,
  chargeTransferPricePerMile: (state, getters, rootState) => tryGet(() => Number(rootState.authentication.agency.advance_setting.charge_transfer_price_per_mile)) || 0.625,
  chargeTransferIncludeReimbersement: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.charge_transfer_include_reimbersement) || false,
  shiftJobReportAdminOnly: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.shift_job_report_admin_only) || false,
  allowTip: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.allow_tipping) || false,
  notAllowTipAfterCharge: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.not_allow_tip_after_charge) || false,
  candidateTagsMatchingOptionSchedulerView: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candiate_tags_matching_options_scheduler_view) || 'All Of',
  disableDefaultShiftJobDistanceSearch: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.disable_shift_job_default_distance_search) || false,
  disableDefaultPlacementDistanceSearch: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.disable_placement_job_default_distance_search) || false,
  candidateNotAllowReview: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_not_allow_review) || false,
  publicJobStartDateLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.public_job_start_date_label) || 'Start Date',
  publicJobEndDateLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.public_job_end_date_label) || 'End Date',
  publicJobStartTimeLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.public_job_start_time_label) || 'Start Time',
  publicJobEndTimeLabel: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.public_job_end_time_label) || 'End Time',
  sendSMSCandidateNotificationOnAssignJob: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.send_candidate_assign_confirmation_sms_shift_job) || false,
  sendSMSClientNotificationOnAssignJob: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.send_client_assign_confirmation_sms_shift_job) || false,
  useBookedTimeIfNoClockedTime: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.use_booked_time_if_no_clocked_time) || false,
  defaultPlacementJobImage: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.default_placement_job_image) || '',
  customMinutesIntervalBookingTime: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_minute_interval_booking_time) || 15,
  bookingMinutesIntervalShiftJobCalendar: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.booking_minutes_interval) || 15,
  customizeSubmitReportButtonLabel: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.customize_submit_report_button_label) || '',
  allowBookOnBlockedDate: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.allow_book_on_blocked_date) || false,
  jobStatusForBlockedDate: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.job_status_blocked_out_date) || 'Requested',
  customMessageRequestForBlockedDates: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.custom_text_job_blocked_dates) || DEFAULT_TEXT_SUBMIT_JOB_FOR_BLOCKED_DATES,
  candidateAcceptMatchingCategory: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_accept_matching_category) || false,
  candidateSeeMatchingCategory: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_see_matching_category) || false,
  shiftJobBroadcastCandidateTableFields: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.shift_job_broadcast_candidate_table_fields) || [],
  placementJobBroadcastCandidateTableFields: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.placement_job_broadcast_candidate_table_fields) || [],
  placementOfPriceInfoFields: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.placement_of_price_info_fields) || [],
  labelForShiftJobInterestedButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_interested_button) || "I'M INTERESTED",
  labelForShiftJobNotInterestedButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_not_interested_button) || "I'M NOT INTERESTED",
  labelForShiftJobMightBeInterestedButton: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.customize_label_for_shift_job_might_be_interested_button) || "I MIGHT BE INTERESTED",
  initFilterLocationByClientLocation: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.initial_filter_location_by_client_location) || false,
  statusHiddenPastDateShiftJobCalendar: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.status_hidden_past_date_shift_job_calendar) || [],
  zoomLevelOfJobMap: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.zoom_level_of_job_map) || 13,
  placementJobAnalyticsDashboardFields: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.placement_job_analytics_dashboard_fields) || ['status'],
  defaultCandidateHideStatusesShiftJobBroadcast: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.default_candidate_hide_statuses_shift_job_broadcast) || [],
  defaultCandidateHideStatusesPlacementJobBroadcast: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.default_candidate_hide_statuses_placement_job_broadcast) || [],
  hideShiftJobDuplicateButton: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.hide_shift_job_duplicate_button) || false,
  reverseDefaultDateSortOrderShiftJobTable: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.reverse_default_date_sort_order_shift_table_view) || false,
  hideShiftJobUpdateManagerSection: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.hide_shift_job_update_manager) || false,
  getUserLocationWhenClockInOut: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.get_user_location_when_clock_in_out) || false,
  shiftJobCalendarTitleAvailableJobBoard: (state, getters, rootState) => {
    let result = tryGet(() => rootState.agency.agencyPublic.public_advance_setting.shift_job_calendar_title_available_job_board) || DEFAULT_SHIFT_JOB_CALENDAR_TITLE_AVAILABLE_JOB_BOARD
    if (getters.hideClientNameCandidateViewAvailableShiftJob) {
      result = result.replace('[[poster_first_name]] ', '');
    }
    return result;
  },
  showMapLocations: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_map_job_board) || false,
  showShiftMapLocations: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.show_map_shift_job_board) || false,
  showClientProfileOnJobListings: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.show_client_profile_on_job_listings) || false,
  candidateTypesCanViewClientProfile: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_types_can_view_client_profile) || [],
  candidateStatusesCanViewClientProfile: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_statuses_can_view_client_profile) || [],
  isCandidateEditableViewDefault: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.advance_setting.set_editable_view_default_candidate) || false,
  jobId: state => state.jobId || undefined,
  candidateDeclinedShiftJobNotificationTarget: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.candidate_declined_shift_job_notification_target) || [],
  doNotBookOutsideOfficeHours: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.do_not_book_outside_office_hours) || false,
  warningBookOutsideOfficeHours: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.warning_book_outside_office_hours) || DEFAULT_MESSAGE_BOOKING_OUTSIDE_OFFICE_HOUR,
  shiftJobStatusAfterDragDropToAssign: (state, getters, rootState) => tryGet(() => rootState.authentication.agency.advance_setting.shift_job_status_after_drag_drop_to_assign) || 'Assigned',
  candidateMatchingCategoryField: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.candidate_matching_category_field) || null,
  onlyShowMatchedZipcodes: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.only_show_matched_zipcodes) || false,
  minDurationPerTypes: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_types) || null,
  minDurationPerCategories: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_categories) || null,
  minDurationPerLocations: (state, getters, rootState) => tryGet(() => rootState.agency.agencyPublic.public_advance_setting.minimum_hours_per_locations) || null,
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js